import React, { useEffect, useRef } from "react";
import { Button, Card, Form, Layout, Skeleton, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import * as ducks from "../../../redux/aspirante/aspiranteDucks";
import * as catDucks from "../../../redux/aspirante/catalogoDucks";

import * as func from "../../../utils";
import { DATE_FORMAT, ERROR } from "../../../utils";
import {
  DatosContacto,
  DatosPersonales,
} from "../../../components/Public/Aspirante";

const style = {
  backgroundColor: "#fff",
  textAlign: "left",
};

/**
 * Component que muestra la página de los datos del aspirante
 * @export
 * @return {JSX.Element}
 */
export const DatosAspirantePage = () => {
  //Hooks
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isMounted = useRef(true);
  //Se accede al state de aspirante
  const { correo } = useSelector((state) => state.usuarioLogin);
  const { isConsulta } = useSelector((state) => state.aspirante.consulta);
  const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
  const { estatusPostulacion } = useSelector(
    (state) => state.bloqueoEstatus.concurso
  );
  const { loading, aspiranteById, loadingForm } = useSelector(
    (state) => state.aspirante
  );
  const { isSaved, isError, mensaje } = useSelector(
    (state) => state.aspirante.formulario
  );

  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    return () => {
      /* isMounted.current = false; */ //Desmontar el componente
      /* dispatch(ducks.cleanAspirante()); */
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //useEffect que carga los datos del aspirante
  useEffect(() => {
    dispatch(ducks.setIsConsulta(true, false));
    if (isMounted.current) {
      //Se carga el catálogo de estados
      dispatch(catDucks.getCatEstados());
      dispatch(catDucks.getCatEstadosExt());
      //Consultar aspirante
      dispatch(ducks.getAspiranteById());
      dispatch(catDucks.getCatMediosComunicacion());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //useEffect que valida si hubo un error al registrar el aspirante o se guardó correctamente.
  useEffect(() => {
    isMounted.current && validaFormulario();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, isSaved, mensaje]);

  /**
   * Función que muestra los mensajes de acuerdo a la respuesta de guardado. (Beta)
   */
  const validaFormulario = () => {
    if (isSaved) {
      func.openModalSucces("Éxito", mensaje); //Muestra el modal
      dispatch(ducks.setIsConsulta(true, false)); //Se cambia a modo consulta
      dispatch(ducks.setFormularioClean()); // Se limpia el state de mensajes
      //Modo prueba
      // dispatch(ducks.getAspiranteById());
      window.scrollTo(0, 0);
    }
    if (isError) {
      func.openModalError(ERROR, mensaje);
      dispatch(ducks.setFormularioClean()); // Se limpia el state de mensajes
    }
  };

  /**
   * Función para cancela los cambios del aspirante y limpia el state de mensajes
   */
  const onCancelar = () => {
    form.resetFields(); //Se limpiar cualquier input que se haya modificado
    const { idEstado, idMunicipio } = aspiranteById;
    dispatch(ducks.setIsConsulta(true, false)); //Switch de isConsulta/isModifica
    if (form.isFieldTouched("idMunicipio") && idMunicipio) {
      dispatch(catDucks.setCatMunicipios([])); //Se limpia el state
      dispatch(catDucks.getCatMunicipios(idEstado)); //Se cargan los municipios
      form.setFieldsValue({ idMunicipio }); //Se asigna el municipio
    }
    dispatch(ducks.setFormularioClean()); // Se limpia el state de mensajes
  };

  /**
   * Función que permite actualizar la información del aspirante.
   */
  const onSaveForm = () => {
    const { idAspirante } = aspiranteById;
    form.validateFields().then((values) => {
      let jsonForm = func.trimObjectJson(values);
      if (func.validaInfoPersonal(jsonForm)) {
        //Format date
        jsonForm.fechaNacimiento = func.formatFecha(
          values.fechaNacimiento,
          DATE_FORMAT
        );
        jsonForm.idAspirante = idAspirante; //Se agrega el idAspirante al json
        jsonForm.email = correo; //Se agrega el email al json
        // console.log(usuario)
        dispatch(ducks.updateAspirante(jsonForm));
      }
    });
  };

  return (
    <Layout>
      {/* <Content style={{ padding: "50px 50px" }}> style={{ minHeight: "100vh" }}*/}
      <div className="site-layout-content-admin">
        <Spin size="large" spinning={loading}>
          {!loading ? (
            <Spin size="large" spinning={loadingForm}>
              <Form form={form} layout="vertical">
                <div className="mt-2">
                  <Card
                    id="registro-card"
                    // title="Datos personales"
                    bodyStyle={style}
                  >
                    {/* Datos del aspirante */}
                    <DatosPersonales isRegistro={false} form={form} />
                  </Card>
                </div>
                <div className="mt-2">
                  <Card title="Domicilio">
                    {/* Direccion del aspirante */}
                    <DatosContacto form={form} />
                  </Card>
                </div>
              </Form>

              <center>
                {isConsulta && (
                  <Button
                    type="primary"
                    onClick={() => dispatch(ducks.setIsConsulta(false, true))}
                    style={{ marginRight: 8 }}
                    disabled={bloquearPorFecha || estatusPostulacion}
                  >
                    Editar
                  </Button>
                )}

                {!isConsulta && (
                  <>
                    <Button
                      type="primary"
                      onClick={() => onSaveForm()}
                      style={{ marginRight: 8 }}
                    >
                      Actualizar
                    </Button>

                    <Button
                      type="default"
                      onClick={() => onCancelar()}
                      style={{ marginRight: 8 }}
                    >
                      Cancelar
                    </Button>
                  </>
                )}
              </center>
            </Spin>
          ) : (
            <Skeleton active paragraph={{ rows: 15 }} />
          )}
        </Spin>
      </div>
      {/* </Content> */}
    </Layout>
  );
};
